import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  NgZone,
  Renderer2,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {PageAnchorDirective} from './directives/page-anchor.directive';
import {PageLayoutService} from '../../../../../../services/menu/page-layout.service';
import {fromEvent, interval, of, Subscription} from 'rxjs';
import {delay, timeout} from 'rxjs/operators';

declare var ResizeObserver;

@Component({
  selector: 'app-page-body',
  templateUrl: './page-body.component.html',
  styleUrls: ['./page-body.component.scss'],
})
export class PageBodyComponent implements OnDestroy, OnInit {
  isPageScrolled = false;
  isPageScrolledNavRight = false;
  navbarRightItems: PageAnchorDirective[] = [];
  HEIGHT_NAVBAR = 60;
  _widthPageContent = '100vw-250px';
  _contentRef: ElementRef;
  subs: Subscription[] = [];
  subContentref = null;
  @Input() titre: string;
  @Input() hasRetour = false;
  @Input() hasBackground = false;
  @Input() boutonRetourSansFondBlanc = false;
  @Input() isHeaderVisible = true;
  @Output() retour = new EventEmitter<void>();
  @ViewChild('pageBaseContent', {static: true}) set contentRef(value: ElementRef) {
    if (this.subContentref) {
      this.subContentref.unsubscribe();
      this.subContentref = null;
    }
    if (value && value.nativeElement) {
      this._widthPageContent = value.nativeElement.offsetWidth + 'px';
    }
    this._contentRef = value;
  }

  pageWidth = 500;
  pageResizeObserver;

  get contentRef() {
    return this._contentRef;
  }
  headerRight: TemplateRef<any>;

  constructor(private pageLayoutService: PageLayoutService, private zone: NgZone) {}

  ngOnInit() {
    this.subs.push(
      this.pageLayoutService.headerRight$
        .asObservable()
        .pipe(delay(0))
        .subscribe(value => {
          this.headerRight = value;
        }),
    );
    this.subs.push(
      this.pageLayoutService.itemsChange.pipe(delay(0)).subscribe(items => {
        this.navbarRightItems = items;
      }),
    );
    this.subs.push(
      of(true)
        .pipe(delay(0))
        .subscribe(() => {
          if (this.contentRef.nativeElement) {
            this._widthPageContent = this.contentRef.nativeElement.offsetWidth + 'px';
          }
        }),
    );

    this.pageResizeObserver = new ResizeObserver(entries => {
      this.zone.run(() => {
        this.pageWidth = entries[0].contentRect.width;
      });
    });
    this.pageResizeObserver.observe(this.contentRef.nativeElement);
  }

  get hasNavbarRightItems() {
    return this.navbarRightItems != null && this.navbarRightItems.length > 0;
  }

  private clearSubscriptions() {
    this.subs.forEach(it => {
      it.unsubscribe();
    });
    this.subs = [];
  }

  ngOnDestroy(): void {
    this.clearSubscriptions();
    this.pageLayoutService.clearNavbarRight();
    this.pageLayoutService.clearMenus();
    this.pageLayoutService.headerRightRef = null;
    this.pageResizeObserver.unobserve(this.contentRef.nativeElement);
  }

  @HostListener('window:scroll', []) onWindowScroll() {
    const contentRefTop = this.contentRef.nativeElement.getBoundingClientRect().top;
    this.isPageScrolled = Math.round(contentRefTop) < this.HEIGHT_NAVBAR;
    this.isPageScrolledNavRight = Math.round(contentRefTop) < this.HEIGHT_NAVBAR;
  }

  onRetour() {
    this.retour.emit();
  }

}
